import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AnyAction } from 'redux';

import * as constants from 'redux/constants/contactSettings.constants';
import { getContact, saveContact, sendEmail } from 'services/contactSettings.services';

export function* settingsGetContact(): Generator {
  try {
    const { data }: any = yield call(getContact);
    yield put({
      type: constants.SETTINGS_ON_GET_CONTACT_SUCCEEDED,
      data,
    });
  } catch (error) {
    yield put({ type: constants.SETTINGS_ON_GET_CONTACT_FAILED, error });
  }
}

export function* settingsSaveContact(action: AnyAction): Generator {
  try {
    const { formData } = action;
    const { data }: any = yield call(saveContact, formData);
    yield put({
      type: constants.SETTINGS_ON_SAVE_CONTACT_SUCCEEDED,
      data,
    });
  } catch (error) {
    yield put({ type: constants.SETTINGS_ON_SAVE_CONTACT_FAILED, error });
  }
}

export function* sendContactEmail(action: AnyAction): Generator {
  try {
    const { formData } = action;
    const { data }: any = yield call(sendEmail, formData);
    yield put({
      type: constants.SEND_CONTACT_EMAIL_SUCCEEDED,
      data,
    });
  } catch (error) {
    yield put({ type: constants.SEND_CONTACT_EMAIL_FAILED, error });
  }
}

export function* watchContactSettings(): Generator {
  yield all([
    takeLatest(constants.SETTINGS_ON_GET_CONTACT_REQUESTED, settingsGetContact),
    takeLatest(constants.SETTINGS_ON_SAVE_CONTACT_REQUESTED, settingsSaveContact),
    takeLatest(constants.SEND_CONTACT_EMAIL_REQUESTED, sendContactEmail),
  ]);
}
